import api from "@/services/api"
import type { Product } from "@/services/sharedTypes/products"

export const retrieveProduct = async (
  productId: string
): Promise<Product> => {
  const response = await api.get<Product>(
    `/products/products/${productId}`
  )
  return response.body
}
